const cardItems = [
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20corporate%20empire%20with%20warm%20crimson%20and%20gold%20tones%20stylized%20building%20structures%20and%20hidden%20connections%20dramatic%20lighting%20representing%20business%20investigation%20sophisticated%20art%20composition&width=800&height=500&seq=cards-01&orientation=landscape',
    title: '深扒某顶流的商业版图与背后资本',
    desc: '从代言品牌到关联公司，一层层揭开流量明星背后的资本运作网络。',
    date: '2026-07-29',
    reads: '12.8万',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20timeline%20illustration%20showing%20rise%20and%20fall%20narrative%20with%20warm%20amber%20and%20deep%20red%20gradients%20abstract%20figure%20descending%20dramatic%20cinematic%20lighting%20sophisticated%20editorial%20style&width=800&height=500&seq=cards-02&orientation=landscape',
    title: '从练习生到塌房：某偶像的五年沉浮',
    desc: '五年时间，一个偶像如何从万众瞩目走向全网封杀，完整复盘。',
    date: '2026-07-28',
    reads: '9.6万',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20with%20split%20screen%20composition%20warm%20red%20and%20gold%20palette%20contrasting%20real%20and%20fake%20scenes%20representing%20reality%20show%20editing%20manipulation%20sophisticated%20modern%20art&width=800&height=500&seq=cards-03&orientation=landscape',
    title: '综艺剪辑有多离谱？真实vs播出对比',
    desc: '同一场景不同版本，揭开综艺剪辑师如何操控观众情绪和认知。',
    date: '2026-07-27',
    reads: '8.3万',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20with%20mysterious%20atmosphere%20warm%20crimson%20and%20amber%20lighting%20hidden%20figures%20behind%20curtains%20dramatic%20shadows%20representing%20internet%20celebrity%20hidden%20rules%20and%20secrets%20sophisticated%20editorial%20style&width=800&height=500&seq=cards-04&orientation=landscape',
    title: '网红圈的潜规则：你不知道的那些事',
    desc: '从签约套路到数据造假，一个前MCN运营的万字深度揭秘。',
    date: '2026-07-26',
    reads: '11.2万',
  },
  {
    imageUrl: 'https://readdy.ai/api/search-image?query=Conceptual%20editorial%20illustration%20of%20fan%20culture%20evolution%20with%20warm%20golden%20and%20red%20tones%20abstract%20crowd%20transforming%20into%20corporate%20structure%20dramatic%20cinematic%20lighting%20sophisticated%20art%20composition&width=800&height=500&seq=cards-05&orientation=landscape',
    title: '饭圈文化二十年：从追星到资本游戏',
    desc: '二十年间，粉丝文化如何从单纯的热爱变成一门精密的生意。',
    date: '2026-07-25',
    reads: '7.5万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">深扒档案</h2>
          <p className="mt-2 text-sm text-foreground-500">深度调查与独家爆料精选</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.reads} 阅读
                  </span>
                </div>
              </div>
            </div>
          ))}
          {cardItems.slice(3).map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span>{item.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.reads} 阅读
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}